import { useEffect, useState } from 'react';
import classNames from 'classnames';

import Card from '../../../components/card/card';
import styles from '../plan.module.scss';
import CardEditButton from '../../../components/card-edit-button/card-edit-button';
import { mapCurrencyToSymbol } from '../../../utils/currency.util';
import { Service } from '../../../types/service.type';
import { Plan } from '../../../types/plan.type';

type ExtendedPlan = Plan & {
    price: number;
    currency: string;
    name: string;
    serviceCode: string;
};

type Props = {
    services: Service[];
    pricingType: string;
    currentStep: number;
    shown: boolean;
    onPlan: (plan: Plan) => void;
    onStep: (step: number) => void;
};

const PlansCard = ({
    services,
    pricingType,
    currentStep,
    shown,
    onStep,
    onPlan,
}: Props) => {
    const [plans, setPlans] = useState<ExtendedPlan[]>([]);

    useEffect(() => {
        services.length > 0 && getPlans(services);
    }, [services]);

    const getPlans = (services: Service[]) => {
        const plans: ExtendedPlan[] = [];
        for (const service of services) {
            const plan = service.plans?.find(
                (plan) => plan.type === pricingType
            );
            if (!plan) continue;
            const { currency, price } = plan.prices[0];
            plans.push({
                ...plan,
                price,
                currency,
                name: service.name,
                serviceCode: service.code,
            });
        }
        setPlans(plans);
    };

    return (
        <Card
            className={classNames({
                [styles.card]: true,
                [styles.shown]: shown,
            })}
        >
            <CardEditButton
                shown={currentStep !== 1}
                onClick={() => onStep(1)}
            />
            <span
                className={classNames({
                    [styles.cardTitle]: true,
                    [styles.active]: currentStep === 1,
                })}
            >
                Escoge el que más se adapte a ti:
            </span>
            <div className={styles.planList}>
                {plans.map((plan) => (
                    <div
                        key={plan.id}
                        className={styles.plan}
                        onClick={() => onPlan(plan)}
                    >
                        <div className={'column justify-center'}>
                            <span className={styles.name}>{plan.name}</span>
                            <span className={styles.description}>
                                {plan.description}
                            </span>
                        </div>
                        <div className={'column justify-center'}>
                            <span className={styles.price}>
                                {mapCurrencyToSymbol(plan.currency)}{' '}
                                {plan.price}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
            {/*<PaymentTypeToggle onType={planState.selectType} />*/}
        </Card>
    );
};

export default PlansCard;
